import request from "@/util/request.js";

export const applyTrial = (data) =>
  request({
    url: "/admin/platform/applyTrial/apply",
    method: "POST",
    data,
  });
